module.exports = __webpack_public_path__ + "img/logo.75c5eb7b.svg";